
import { Component, Vue, Prop} from 'vue-property-decorator';
import ChildrenSurvey from "./ChildrenSurvey.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";
import PageBase from "../../PageBase.vue";

import {SearchForChildrenData} from "@/components/utils/ChildrenData/SearchForChildrenData"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
      ChildrenSurvey,
      PageBase
    }
})
export default class CmChildrenInfo extends Vue {

    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public steps!: stepInfoType[];    

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    currentStep=0;
    currentPage=0;
    showTable = true;
    childData = [];
    anyRowToBeEdited = null;
    editId = null; 
    dataReady = false; 
    
    selectedChildrenRelated = '';
    
    public openForm(anyRowToBeEdited?) {
        this.showTable = false;
         Vue.nextTick(()=>{
            const el = document.getElementById('child-info-survey')            
            if(el) el.scrollIntoView();
        })
        if(anyRowToBeEdited) {
            this.editId = anyRowToBeEdited.id;
            this.anyRowToBeEdited = anyRowToBeEdited;
        } else {
            this.anyRowToBeEdited = null;
        }
    }

    public childComponentData(value) {
        this.showTable = value;
    }

    public populateSurveyData(childValue) {
        const currentIndexValue =
            this.childData.length > 0 ? this.childData[this.childData.length - 1].id : 0;
        const id = currentIndexValue + 1;
        const newChild = { ...childValue, id };
        this.childData = [...this.childData, newChild];

        this.showTable = true; 
    }

    public deleteRow(rowToBeDeleted) {
        this.childData = this.childData.filter(data => {
            return data.id !== rowToBeDeleted;
        });
    }

    public editRow(editedRow) {
        this.childData = this.childData.map(data => {
            return data.id === this.editId ? editedRow : data;
        });
        this.showTable = true;
    }

    public onPrev() {
       Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        Vue.prototype.$UpdateGotoNextStepPage();
    }

    mounted(){
        this.dataReady = false;            
        
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;
        
        if (this.step.result?.cmChildrenInfoSurvey?.data){
            this.childData = this.step.result.cmChildrenInfoSurvey.data.childData;
            this.selectedChildrenRelated = this.step.result.cmChildrenInfoSurvey.data.childRelatedType
        }

        if(this.childData?.length == 0){
            this.childData= SearchForChildrenData('CM');            
        }

        this.dataReady = true;
    }

    public situationChanged(){
        Vue.filter('surveyChanged')('caseMgmt');
    }

    public isDisableNext() {
        const disableNext = (!this.selectedChildrenRelated) || (this.selectedChildrenRelated=='A party to the case and the case involves a child-related issue' && this.childData.length <= 0);
        const progress = disableNext? 50: 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);  
        return disableNext
    }

    beforeDestroy() {       
        this.UpdateStepResultData({step:this.step, data: {cmChildrenInfoSurvey: this.getChildrenResults()}})       
    }

    public getChildrenResults(){
        
        const questionResults: {name:string; value: any; title:string; inputType:string}[] =[];
        
        questionResults.push({name:'childRelatedType', value: this.selectedChildrenRelated, title:'Select the option that applies to your situation', inputType:''})
        
        if(this.selectedChildrenRelated=='A party to the case and the case involves a child-related issue'){
            for(const child of this.childData)
            {
                questionResults.push({name:'childInfoSurvey', value: this.getChildInfo(child), title:'Child '+child.id +' Information', inputType:''})
            }
        }

        return {data: {childData:this.childData, childRelatedType: this.selectedChildrenRelated}, questions:questionResults, pageName:'Children Information', currentStep: this.currentStep, currentPage:this.currentPage}
    }

    public getChildInfo(child){
        const resultString = [];

        resultString.push(Vue.filter('styleTitle')("Name: ")+Vue.filter('getFullName')(child.name));
        resultString.push(Vue.filter('styleTitle')("Birthdate: ")+Vue.filter('beautify-date')(child.dob))          
        
        return resultString
    }
}
